(function() {
  acps = {};
  if((navigator.userAgent).indexOf('Firefox')!==-1){
    document.getElementById('ffWarning').style.display = 'block';
  }
  document.getElementById('editableDiv').focus();
  document.getElementById('editableDiv').addEventListener('paste', handlePaste);
  var dlbutton = document.getElementById('download-acps');
  dlbutton.onclick = function(e){
    e.preventDefault();
    // convert array to csv
    var dlcsv = objectValuesToCSV(acps.processed);    
    downloadBlob(dlcsv, 'acp-segments.csv', 'text/csv;charset=utf-8;');
  };

  var chromLengths = [
  249250621,243199373,198022430,191154276,180915260,171115067,159138663,146364022,141213431,135534747,135006516,133851895,115169878,107349540,102531392,90354753,81195210,78077248,59128983,63025520,48129895,51304566,155270560,59373566
  ];

  window.addEventListener('keydown', function(e) {
    if (e.keyIdentifier == 'U+000A' || e.keyIdentifier == 'Enter' || e.keyCode == 13) {
        e.preventDefault();
        return false;
    }
}, true);

function handlePaste(e) {
  var clipboardData, pastedData;
  // Stop data actually being pasted into div
  e.stopPropagation();
  e.preventDefault();

  // Get pasted data via clipboard API
  clipboardData = e.clipboardData || window.clipboardData;
  pastedData = clipboardData.getData('text/html');
 
  var suc = parseAncestryEthnicitySegments(pastedData);
  if(suc){
    document.getElementById('acpsFailure').style.display = 'none';
    document.getElementById('acpsSuccess').style.display = 'block';
    document.getElementById('enterarea').style.display = 'none';
    document.getElementById('instructions').style.display = 'none';
    if(isLoggedIn){
      generateMapFiles();
      document.getElementById('newprofilename').value = 'AncestryDNA Chromosome Painter';
      document.getElementById('newprofiledesc').value = 'Generated '+new Date().toLocaleDateString();
      document.getElementById('newprofilegen').value = 'u';
      document.getElementById('chromomapper').value = JSON.stringify(chromomapper);
      document.getElementById('chromogroups').value = JSON.stringify(chromogroups);

      // ideally call something already written
      // otherwise write something simple for this use case.
      var pName = parseAncestryProfileName(pastedData);
      if(pName){
        document.getElementById('newprofilename').value = pName+ ': ' + document.getElementById('newprofilename').value;
      }

    }
    // if logged in, populate these fields:   chromomapper, chromogroups

  }
  else {
    document.getElementById('enterarea').style.display = 'block';
    document.getElementById('instructions').style.display = 'block';
    document.getElementById('acpsSuccess').style.display = 'none';
    document.getElementById('acpsFailure').style.display = 'block';
  }
}

function figureOutSide(thisside){
  if(thisside.indexOf('1')!==-1 || thisside.indexOf('FÃ¤dernet')!==-1 || thisside.indexOf('VÃ¤ter')!==-1 || thisside.indexOf('pat')!==-1){
    return 'Paternal';
  }
  else if(thisside.indexOf('2')!==-1 || thisside.indexOf('MÃ¶dernet')!==-1 || thisside.indexOf('MÃ¼tter')!==-1 || thisside.indexOf('mat')!==-1){
    return 'Maternal';
  }
  return 'both';
}

function generateMapFiles(){
  chromomapper = [];
  chromogroups = [];
  for(var s in acps.processed){
      if(acps.processed[s].side!='Paternal' && acps.processed[s].side!='Maternal'){
        acps.processed[s].side = figureOutSide(acps.processed[s].side);
      }    
      var groupindex = getOrCreateGroup(
        chromogroups,
        "AncestryDNA "+acps.processed[s].group+" "+acps.processed[s].side,
        (acps.processed[s].side.substring(0,3)).toLowerCase(),
        acps.processed[s].color,
        "AncestryDNA Chromosome Painter",
        new Date().toLocaleDateString(),
        '','','eth');

        addNewSegment(chromomapper, acps.processed[s].chr, acps.processed[s].group, acps.processed[s].start, acps.processed[s].end, '', '', groupindex, 3, '');

  }

}


function getEndPos(chr, startPos, thisSegWidth, thisChromPxLength){
 var debug = false;
 if(debug && chr==1){
  console.log(parseFloat(startPos));  
  console.log(parseFloat(thisSegWidth));  
  console.log(parseFloat(thisChromPxLength)); 
  }
 
  var chromLength = chromLengths[parseInt(chr)-1];
   if(debug){
     console.log('calc is: '+startPos+ ' + '+'('+parseFloat(thisSegWidth)+' divided by'+parseFloat(thisChromPxLength)+' ) times '+chromLength); 
   }

  return parseInt(
    parseInt(startPos) + 
    ((parseFloat(thisSegWidth) / (parseFloat(thisChromPxLength))
    * chromLength))
    );
}

function mergeConsecutive(){

}

function objectValuesToCSV(data){
  var csvlines = ["chr,start,end,group,color,ancestry side"];
  for(var i in data){
    var thisone = data[i];
    //console.log(data[i][chr]);

    var thisline = '"'+data[i].chr+'",'+data[i].start+','+data[i].end+',"AncestryDNA '+data[i].group+' '+data[i].side+'","'+data[i].color+'","'+data[i].side+'"';
      csvlines.push(thisline);  
  }
  //console.log(csvlines.join("\r\n"));
  return csvlines.join("\r\n");
}

/** Download contents as a file
 * Source: https://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side
 */
function downloadBlob(content, filename, contentType) {
  // Create a blob
  var blob = new Blob([content], { type: contentType });
  var url = URL.createObjectURL(blob);

  // Create a link to download it

  var pom = document.createElement('a');
  pom.href = url;
  pom.setAttribute('download', filename);
  pom.click();
 
}
function parseAncestryProfileName(pastedData){
  var reg = /Inheritance for (.+?)</;
  var pName = pastedData.match(reg);
  if(pName){
    return pName[1];
  }
  return false;
  //console.log(pName);
  // Inheritance for Jonathan Perl<
  //parseAncestryEthnicitySegments
}

function parseAncestryEthnicitySegments(pastedData){
  var reg = /<div class="chromosomes"(.*)<section/;
  var masterData = pastedData.match(reg);
  document.getElementById('looksLikeFirefox').style.display = 'none';

  // wow Firefox omits this wrapper div somehow!
  // tried to fix but it also omits the segments.
  /*if(!masterData){
    console.log('try 2');
    var reg = /chromosomeSection/;
    var looksRight = pastedData.match(reg);
    if(looksRight){
      masterData = [pastedData];
    }
    console.log(masterData);
  }*/
    if (masterData) {
      var parser = new DOMParser();
      var parsedHtml = parser.parseFromString(masterData[0], "text/html");
      var chroms = parsedHtml.getElementsByClassName("chromosome");
      chroms = Array.from(chroms);
      //chroms.length = 22;
      if(chroms.length ==44){
        chroms = chroms.slice(22,44);
        //console.log(chroms.slice(22,44));
      }
      acps.processed = [];

        for(var c in chroms){
          var thischr = chroms[c].firstChild.innerText;      
          var sides = chroms[c].getElementsByClassName("parent");
          sides = Array.from(sides);
          for(var s in sides){
            var startPos = 1;

            var chromLength = sides[s].firstChild.style.width;

            var thisside = sides[s].getAttribute('aria-label').replace('Â ',' ');
            var sections = sides[s].getElementsByClassName("chromosomeSection");
            var currentGroup = '';

            sections = Array.from(sections);
            for(var b in sections){
              var segs = sections[b].getElementsByClassName("chromosomeRegion");
              segs = Array.from(segs);
              for(var seg in segs){
                var thisSegWidth = segs[seg].style.width;
                var thiscolor = segs[seg].style.backgroundColor;
                var thisgroupstring = segs[seg].firstChild.innerText;
                var thisgroupbits = thisgroupstring.split(":");
                var thisgroup = thisgroupbits[0].replace(/ segment/,'');
                thisgroup = (thisgroup.replace(/Segment /,'')).trim();
                var thisstart = startPos;
                var thisend = getEndPos(thischr,startPos,thisSegWidth,chromLength);
                //console.log(currentGroup+'_'+thischr+'_'+thisstart);
                //console.log(thisgroup);

                if(currentGroup==thisgroup){
                  // merge the segs - they have just been split by the centromere
                  acps.processed[acps.processed.length-1].end = thisend;
                }
                else {
                  var thisseg = {'chr': thischr, 'start': thisstart, 'end': thisend, 'group': thisgroup, 'color': thiscolor, 'side': thisside};
                  acps.processed.push(thisseg);   
                }

                startPos = thisend+1;
                currentGroup = thisgroup;

              }
            }
          }

        }

   
    //console.log(acps.processed);



      return true;
    }
    else {
      document.getElementById('pastedData').innerText = pastedData;
      var looksLikeFirefox = false;
      if(pastedData.indexOf('BannerRegion')!==-1){
        looksLikeFirefox = true;
      }
      if(looksLikeFirefox){
        document.getElementById('looksLikeFirefox').style.display = 'block';
      }
      return false;
    }
}
 

})();